import Main from './ProfilesMain'
import New from './ProfilesNew'
import Edit from './ProfilesEdit'

export default {
  Main,
  New,
  Edit,
}
